var _path, _path2, _polygon, _path3, _polygon2, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _circle2, _path14, _path15, _circle3, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManegerroute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 895.01001,
    height: 602.68057,
    viewBox: "0 0 895.01001 602.68057",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.495,751.34028h895.01C546.498,643.50477,225.76068,739.53309,152.495,751.34028Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M528.9264,397.79261a7.74428,7.74428,0,0,0-10.77619-.74018,7.429,7.429,0,0,0-.85423.88247l-25.43913-9.09873-9.15854,11.28393,36.196,8.69647a7.72281,7.72281,0,0,0,9.41776-.4472,7.39069,7.39069,0,0,0,.74928-10.42513Q528.99493,397.8675,528.9264,397.79261Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#a0616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "271.509 536.444 285.395 536.443 292.001 482.879 271.506 482.881 271.509 536.444",
    fill: "#a0616a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M423.51434,699.59033l42.70332-.00161v-.54a16.62223,16.62223,0,0,0-16.62132-16.62106h-.001l-7.80031-5.91772-14.55365,5.91862-3.72772.00013Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "174.175 510.901 185.534 518.887 221.749 478.871 204.982 467.083 174.175 510.901",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M317.937,671.12877l34.93271,24.56176.31064-.44177a16.62224,16.62224,0,0,0-4.03594-23.15684l-.00084-.00059-2.97685-9.32752-15.30945-3.5298-3.04939-2.14409Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M368.67557,418.62743l-1.15381,2.465c-7.58447,16.20317-9.5237,34.316-6.5763,51.962a2.94343,2.94343,0,0,1-.11755,2.09368c-1.82791,2.144,1.03992,11.45883,2.68378,16.66l1.48164,9.19749s-2.45683,8.54207,1.27492,7.91429-1.82526,8.48364,1.73437,10.76624l9.234,57.32155-38.52491,63.49476,14.26848,20.6893L410.05417,587.709l.71342-66.34846,8.5611,53.50682.71342,84.18406L446,656.292l-.988-89.27237,1.42685-105.21883-14.26849-48.93978Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M373.52323,270.23519l36.38464.71343,7.13424,17.8356,14.26848,4.28055,12.12822,29.96381L436.30456,417.914l-77.76324,7.13425,3.56713-7.84767S347.84,417.914,352.83393,412.92s14.58868-3.88731,9.79133-9.79132-5.51078-10.18455-5.51078-10.18455l-2.14028-29.2504-5.35068-62.42461L366.389,288.0708Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#5b6d49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M336.43665,474.33816a7.74427,7.74427,0,0,1,1.918-10.62994,7.42951,7.42951,0,0,1,1.0646-.61245l-2.60044-26.8919L350,430.08334l-.42055,37.2237a7.7228,7.7228,0,0,1-2.737,9.02236,7.39068,7.39068,0,0,1-10.29176-1.82328Q336.49251,474.42293,336.43665,474.33816Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M356.32715,299.73458s-21.21362-.41219-21.93675,38.76335c0,0-25.73342,53.66638-10.00987,72.99818l10.17558,39.378,17.88476-1.67075,1.495-32.5743s24.92418-35.04168,19.38217-68.671Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#5b6d49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M429.88375,292.35134s9.63122,8.20438,27.82354,33.53094c0,0,27.11012,39.23833,24.25642,54.93366l12.12821,3.56713,2.8537,27.11012-29.6071-7.491s-38.1682-31.74738-36.74135-47.44271S429.88375,292.35134,429.88375,292.35134Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#5b6d49"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 240.10275,
    cy: 90.87296,
    r: 24.95861,
    fill: "#a0616a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M385.31262,238.88019q.03207-.41737.08561-.83469A1.87094,1.87094,0,0,1,385.31262,238.88019Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M418.05167,210.34322c-.74913-2.93216-3.59568-5.422-6.60631-5.06529-1.87631.22116-3.47438,1.42685-5.20089,2.18307-4.84414,2.11885-16.90812-2.39-22.13753-1.66943-5.23656.72771-10.25905,5.87147-8.611,10.894-13.56407,1.44383-19.38407,13.4162-14.59668,26.468,3.74409,10.20745,17.97121,20.31117,28.82236,21.0175-1.3341-6.29241-9.0605-13.3339-10.3946-19.61917a12.80132,12.80132,0,0,1-.37809-5.18661,4.3903,4.3903,0,0,1,3.3174-3.6242,2.87791,2.87791,0,0,1,3.13194,2.30439,11.74043,11.74043,0,0,1,17.77138-8.40416l-3.46009-4.70858a27.32057,27.32057,0,0,0,15.11032,2.34,3.62565,3.62565,0,0,0,.12127-1.35548,2.73359,2.73359,0,0,0-1.51246-2.22588,6.33069,6.33069,0,0,1,3.9096,3.07486,12.445,12.445,0,0,0,7.39106-4.944C426.38446,219.2824,418.80076,213.27538,418.05167,210.34322Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M546.365,382.292h-39a7.5,7.5,0,0,0-7.5,7.5v5.17823a7.5,7.5,0,0,0,7.5,7.5h14.90759l-5.3891,51.28894a7.48311,7.48311,0,0,0-3.482,5.41668L508.45,497.86027a7.49827,7.49827,0,0,0,3.05975,7.04224l-16.548,157.49158-23.669,34.19628H278.83325a3,3,0,0,0,0,6h14.99323a19.87181,19.87181,0,1,0,23.82061,0H472.865a3.00085,3.00085,0,0,0,2.4668-1.293l19.5332-28.22168v25.7536a19.87168,19.87168,0,1,0,6,.03912V663.62571l16.54626-157.475a7.49725,7.49725,0,0,0,5.9173-6.386L528.28,461.0803a7.49556,7.49556,0,0,0-5.27924-8.1264l5.30445-50.48364H546.365a7.5,7.5,0,0,0,7.5-7.5V389.792A7.5,7.5,0,0,0,546.365,382.292Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M785.81937,686.02349a3.56386,3.56386,0,0,0,3.21114-5.875c-.05226-.36458-.08972-.62635-.14191-.991a9.57475,9.57475,0,0,1,17.67213,1.67919c3.1729,10.272,7.54557,21.01973,3.70946,31.56726,21.817-35.98464,20.66571-83.7037-2.34456-118.83333-6.87557-4.78169-12.04244-12.5402-12.71511-20.99211,3.48284,1.6009,8.29175-.86543,5.97453-4.95261-1.02481-1.57666-2.0622-3.143-3.08688-4.71973,15.243-13.17336,29.18516,11.49259,12.02681,29.62963a114.26507,114.26507,0,0,1,10.6767,21.29925,48.04332,48.04332,0,0,1,5.173-21.89606c3.41917-6.30166,9.11712-11.31429,14.21947-16.53767,6.20524-6.36576,17.149-1.98552,16.96583,6.89674-5.231,1.13353-6.65175,8.37-.97136,9.97455-3.22767,16.22206-15.50289,30.1568-30.99311,35.79979a114.70949,114.70949,0,0,1,1.24916,48.33895c4.57589-18.612,25.32569-21.07552,40.27868-27.09978a5.54913,5.54913,0,0,1,7.83259,6.47009,32.0509,32.0509,0,0,0-5.89568,2.36361,4.84411,4.84411,0,0,0,1.31877,9.029c-8.9896,16.92881-28.69474,26.86768-47.65163,24.81829a117.92888,117.92888,0,0,1-10.28362,22.17753l-28.14633-2.94253c-.06825-.32328-.12526-.65567-.1834-.9779a32.15289,32.15289,0,0,0,7.83671.35019c-6.0396-8.88153-10.935-13.60238-5.73228-24.576Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 610.79808,
    cy: 707.85537,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-430.03738 850.7171) rotate(-67.37755)",
    fill: "#e6e6e6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 641.32805,
    cy: 729.11576,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-430.87558 891.98051) rotate(-67.37755)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 587.8657,
    cy: 725.33585,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-460.28417 840.30564) rotate(-67.37755)",
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 571.18309,
    cy: 727.48377,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-504.63795 633.15417) rotate(-55.23031)",
    fill: "#e6e6e6"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 555.671,
    cy: 741.96193,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-523.19693 626.63332) rotate(-55.23031)",
    fill: "#3f3d56"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 611.54504,
    cy: 732.91942,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-491.7587 668.64535) rotate(-55.23031)",
    fill: "#e6e6e6"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 600.17422,
    cy: 717.23651,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-483.76224 652.56551) rotate(-55.23031)",
    fill: "#ff6584"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.62576,
    cy: 717.28366,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-471.14503 676.77876) rotate(-55.23031)",
    fill: "#3f3d56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.79808,
    cy: 707.85537,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-545.72185 677.1819) rotate(-67.37755)",
    fill: "#e6e6e6"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 453.32805,
    cy: 729.11576,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-546.56005 718.44532) rotate(-67.37755)",
    fill: "#3f3d56"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.8657,
    cy: 725.33585,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-575.96864 666.77044) rotate(-67.37755)",
    fill: "#ff6584"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 383.18309,
    cy: 727.48377,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-585.42548 478.72138) rotate(-55.23031)",
    fill: "#e6e6e6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 367.671,
    cy: 741.96193,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-603.98445 472.20054) rotate(-55.23031)",
    fill: "#3f3d56"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.54504,
    cy: 732.91942,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-572.54623 514.21257) rotate(-55.23031)",
    fill: "#e6e6e6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 412.17422,
    cy: 717.23651,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-564.54976 498.13272) rotate(-55.23031)",
    fill: "#ff6584"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 441.62576,
    cy: 717.28366,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-551.93256 522.34597) rotate(-55.23031)",
    fill: "#3f3d56"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 726.97528,
    cy: 744.33423,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-436.41252 841.89037) rotate(-59.36455)",
    fill: "#e6e6e6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 699.70704,
    cy: 719.02561,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-428.00936 806.01603) rotate(-59.36455)",
    fill: "#3f3d56"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 752.12049,
    cy: 730.22115,
    rx: 3.50268,
    ry: 5.72778,
    transform: "translate(-411.93737 856.60457) rotate(-59.36455)",
    fill: "#ff6584"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 768.93964,
    cy: 730.41972,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-441.9149 649.99646) rotate(-47.21731)",
    fill: "#e6e6e6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 786.3185,
    cy: 718.24526,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-427.40484 658.84609) rotate(-47.21731)",
    fill: "#3f3d56"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 729.72948,
    cy: 719.41077,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-446.4129 617.68729) rotate(-47.21731)",
    fill: "#e6e6e6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 738.80312,
    cy: 736.52563,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-456.06345 629.83686) rotate(-47.21731)",
    fill: "#ff6584"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 709.64571,
    cy: 732.37346,
    rx: 3.19406,
    ry: 2.50888,
    transform: "translate(-462.36915 607.10528) rotate(-47.21731)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.50416,
    cy: 44.68206,
    r: 44.68206,
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M902.00077,172.18408c-2.577-8.65165-9.87332-14.30788-18.69228-15.54621a1.80854,1.80854,0,0,0-.3012,0,2.37342,2.37342,0,0,0-.36821-.08375c-14.96055-1.94114-31.59453,2.778-42.78984,13.0529l-.12278.11269a22.66351,22.66351,0,0,1-21.46322,5.19844,19.89807,19.89807,0,0,0-6.29343-.69252A22.06179,22.06179,0,0,0,792.22325,190.14a2.55445,2.55445,0,0,0,1.15468,2.82812,11.16684,11.16684,0,0,0,4.66885,2.37625c3.69834.78657,7.43008,1.50614,11.16181,2.1588q10.94426,1.90775,22.00576,3.09582,7.30449.77814,14.64258,1.23833c10.10754.63591,20.26532.78657,30.3896.46861,5.02032-.1673,9.83983-.33471,14.425-2.54366a21.41592,21.41592,0,0,0,8.28354-7.21251A24.34472,24.34472,0,0,0,902.00077,172.18408Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#f2f2f2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M810.07881,237.28088a22.84647,22.84647,0,0,0-.93712-5.52243c-2.59381-8.65165-9.89008-14.30788-18.709-15.54621a1.61457,1.61457,0,0,0-.28456,0,3.15736,3.15736,0,0,0-.38486-.08365,55.54781,55.54781,0,0,0-24.58281,2.52691,50.73436,50.73436,0,0,0-18.319,10.62806,22.6519,22.6519,0,0,1-21.46437,5.20862,19.95833,19.95833,0,0,0-6.303-.69208,22.06163,22.06163,0,0,0-19.74655,15.91441,2.60267,2.60267,0,0,0,1.15467,2.82812,11.26715,11.26715,0,0,0,4.66886,2.37625c3.715.78647,7.43007,1.506,11.17856,2.1587q10.94424,1.90774,21.989,3.09592a326.59468,326.59468,0,0,0,45.04894,1.70684c5.00356-.1673,9.83982-.33461,14.425-2.54356a21.36931,21.36931,0,0,0,8.26679-7.21251A23.87074,23.87074,0,0,0,810.07881,237.28088Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 649.50416,
    cy: 44.68206,
    r: 44.68206,
    fill: "#f2f2f2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M902.00077,172.18408c-2.577-8.65165-9.87332-14.30788-18.69228-15.54621a1.80854,1.80854,0,0,0-.3012,0,2.37342,2.37342,0,0,0-.36821-.08375c-14.96055-1.94114-31.59453,2.778-42.78984,13.0529l-.12278.11269a22.66351,22.66351,0,0,1-21.46322,5.19844,19.89807,19.89807,0,0,0-6.29343-.69252A22.06179,22.06179,0,0,0,792.22325,190.14a2.55445,2.55445,0,0,0,1.15468,2.82812,11.16684,11.16684,0,0,0,4.66885,2.37625c3.69834.78657,7.43008,1.50614,11.16181,2.1588q10.94426,1.90775,22.00576,3.09582,7.30449.77814,14.64258,1.23833c10.10754.63591,20.26532.78657,30.3896.46861,5.02032-.1673,9.83983-.33471,14.425-2.54366a21.41592,21.41592,0,0,0,8.28354-7.21251A24.34472,24.34472,0,0,0,902.00077,172.18408Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M810.07881,237.28088a22.84647,22.84647,0,0,0-.93712-5.52243c-2.59381-8.65165-9.89008-14.30788-18.709-15.54621a1.61457,1.61457,0,0,0-.28456,0,3.15736,3.15736,0,0,0-.38486-.08365,55.54781,55.54781,0,0,0-24.58281,2.52691,50.73436,50.73436,0,0,0-18.319,10.62806,22.6519,22.6519,0,0,1-21.46437,5.20862,19.95833,19.95833,0,0,0-6.303-.69208,22.06163,22.06163,0,0,0-19.74655,15.91441,2.60267,2.60267,0,0,0,1.15467,2.82812,11.26715,11.26715,0,0,0,4.66886,2.37625c3.715.78647,7.43007,1.506,11.17856,2.1587q10.94424,1.90774,21.989,3.09592a326.59468,326.59468,0,0,0,45.04894,1.70684c5.00356-.1673,9.83982-.33461,14.425-2.54356a21.36931,21.36931,0,0,0,8.26679-7.21251A23.87074,23.87074,0,0,0,810.07881,237.28088Z",
    transform: "translate(-152.495 -148.65972)",
    fill: "#e6e6e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManegerroute);
export default __webpack_public_path__ + "static/media/manegerroute.48cad36f6a13224ad0a45dac7ca594a1.svg";
export { ForwardRef as ReactComponent };